import React from 'react';
import type { NewsAEMImages, NewsAEMTimestampLabels } from '../../../interfaces/NewsAEM.interface';
import { formatTimestamp } from '../../../utils/helper';
import Image from "next/image";
import { getFullUrl } from '../../../utils/helper';
interface NewsHeaderProps {
  sourceName?: string;
  sourceLogo?: string;
  timestamp?: string | number;
  className?: string;
  aemImages?: NewsAEMImages;
  timestampLabels?: NewsAEMTimestampLabels;
}

const NewsHeader: React.FC<NewsHeaderProps> = ({
  sourceName,
  sourceLogo,
  timestamp,
  className = '',
  aemImages,
  timestampLabels,
}) => {
  const timeLabels = {
    justNow: timestampLabels?.justNow ?? 'Just now',
    minutesAgo: timestampLabels?.minutesAgo ?? 'm ago',
    hoursAgo: timestampLabels?.hoursAgo ?? 'h ago',
    daysAgo: timestampLabels?.daysAgo ?? 'd ago',
  };
  const defaultLogo = aemImages?.defaultSourceLogo ?? '';
  const logoSrc = sourceLogo ?? defaultLogo;
  const displayName = sourceName ?? '';
  const shouldShowImage = sourceLogo !== undefined && logoSrc !== '';

  return (
    <div className={`flex items-center gap-1 ${className}`}>
        {shouldShowImage && (
          <Image
            src={getFullUrl(logoSrc)}
            width={20}
            height={20}
            alt={displayName}
            className="w-5 h-5 rounded object-cover"
            onError={(e) => {
              const target = e.target as HTMLImageElement;
              if (target.src !== defaultLogo) {
                target.src = defaultLogo;
              } else {
                target.style.display = 'none';
              }
            }}
          />
        )}
      <span className="text-[10px] leading-none md:text-[14px]  md:leading-[20px]  font-rubik font-normal tracking-normal">{displayName}</span>
      {timestamp && (
        <span className="font-['Rubik'] font-normal tracking-normal text-center text-[12px] md:leading-[16px] md:text-[14px] md:leading-[20px] text-[#666666]">• {formatTimestamp(timestamp, timeLabels)}</span>
      )}
    </div>
  );
};

export default NewsHeader;

